import { css } from '@emotion/react';
import { theme } from 'global';

export const pageWrapper = css`
  background: ${theme.colors.white};

  @media screen and (min-width: ${theme.breaks.mdOnboarding}px) {
    background: linear-gradient(
      to right,
      ${theme.colors.primary.lightest} 0%,
      ${theme.colors.primary.lightest} 50%,
      ${theme.colors.white} 50%,
      ${theme.colors.white} 100%
    );
  }
`;

export const pageWrapperPlain = css`
  background: ${theme.colors.white};
`;

export const gridContainer = css`
  height: 100%;
  justify-content: center;
  margin: 0 auto;
  padding: 0 16px;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    padding: 0 24px;
  }

  @media screen and (min-width: ${theme.breaks.mdOnboarding}px) {
    padding: 0 80px;
  }

  @media screen and (min-width: ${theme.breaks.xl}px) {
    padding: 0;
    max-width: 1524px;
  }
`;

export const leftPanelGrid = css`
  display: none;

  @media screen and (min-width: ${theme.breaks.mdOnboarding}px) {
    display: flex;
    justify-content: flex-end;
    min-height: 100vh;
  }
`;

export const rightPanelGrid = (hasLeftPanel) => css`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  justify-content: center;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    max-width: 600px;
    & > .MuiBox-root {
      max-width: 600px;
      width: ${hasLeftPanel ? '100%' : '600px'};
    }
  }

  @media screen and (max-width: ${theme.breaks.mdOnboarding}px) {
    width: 100%;
    & > .MuiBox-root {
      max-width: 600px;
    }
  }
`;

export const topBarGridContainer = css`
  max-width: 1224px;
  margin: 0 auto;
  padding: 0 16px;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    padding: 0 24px;
  }

  @media screen and (min-width: ${theme.breaks.mdOnboarding}px) {
    padding: 0 80px;
  }

  @media screen and (min-width: ${theme.breaks.xl}px) {
    padding: 0;
  }
`;

export const topBar = css`
  display: flex;
  width: 100%;
  height: 64px;
  padding-top: 24px;
`;

export const rightPanelLogo = css`
  display: flex;
  justify-content: flex-start;
  padding: 12px 16px;

  img {
    width: 90px;
    height: 40px;
    display: block;
  }

  @media screen and (min-width: ${theme.breaks.sm}px) {
    padding: 24px;
  }

  @media screen and (min-width: ${theme.breaks.md}px) {
    padding: 24px 48px;
  }

  @media screen and (min-width: ${theme.breaks.mdOnboarding}px) {
    display: none;
  }
`;

export const rightPanelInnerContent = css`
  width: 100%;
  margin: 0 auto;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    padding-bottom: 100px;
  }

  h1 {
    font-family: ${theme.fonts.heading1.family};
    font-size: ${theme.fontSizes.heading1};
    line-height: ${theme.lineHeights.heading1};
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.colors.secondary};
    margin-bottom: 20px;

    @media screen and (max-width: ${theme.breaks.xs}px) {
      margin-bottom: 16px;
    }
  }

  form .MuiFormControl-root {
    margin: 0 0 21px 0;

    .MuiInputLabel-root.MuiInputLabel-shrink {
      transform: translate(14px, -6px) scale(0.75);
    }
  }
`;

export const stepDescription = css`
  color: ${theme.colors.neutral[500]};
  margin: 0 0 20px 0;
`;

export const compactStepDescription = css`
  ${stepDescription};
  margin-top: -8px;
`;
